var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownOrangeIcon = function SvgArrowDownOrangeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#E35600",
    rx: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.068 15.692-5.626 5.625a.625.625 0 0 1-.884 0l-5.625-5.625a.625.625 0 1 1 .885-.884l4.557 4.558V7.125a.625.625 0 0 1 1.25 0v12.241l4.558-4.558a.625.625 0 1 1 .884.884"
  })));
};
export default SvgArrowDownOrangeIcon;